module.exports = __webpack_public_path__ + "img/add.ee2b7ff7.svg";